import { IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

function PdfPreview({ active, setActive }) {
    return (
        <>
            <IconButton
                aria-label="close"
                onClick={() =>
                    setActive((prev) => ({
                        ...prev,
                        open: false
                    }))
                }
                style={{
                    opacity: active?.open ? '1' : '0',
                    pointerEvents: active?.open ? 'all' : 'none',
                    transition: 'all ease-in-out 0.3s',
                    position: 'absolute',
                    top: '13px',
                    right: '10px',
                    zIndex: '999',
                    color: '#eaeaea'
                }}
            >
                <CloseIcon />
            </IconButton>

            <iframe
                src={`https://drive.google.com/file/d/${
                    !!active?.id
                        ? active?.id
                        : '1XRaMFZz_T_N6BUcQpeyqspEXEsL1RdGk'
                }/preview`}
                style={{
                    width: active?.open ? 'calc( 100vw - 24px )' : '0',
                    height: active?.open ? 'calc( 100vh - 70px )' : '0',
                    opacity: active?.open ? '1' : '0',
                    pointerEvents: active?.open ? 'all' : 'none',
                    transition: 'all ease-in-out 0.3s',
                    position: 'absolute',
                    top: '60px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: '999'
                }}
                allow="autoplay"
            >
                Loading ...
            </iframe>
        </>
    )
}

export default PdfPreview
